import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  certificateAndGold: "certificateAndGold [Action]",
  certificateAndGoldLoading: "certificateAndGoldLoading [Action]",
  certificateAndGoldAsync: "certificateAndGoldAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const certificateAndGoldReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.certificateAndGold:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.certificateAndGoldLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.certificateAndGoldLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "GOLD",
    method_type: "certificate_and_gold",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.certificateAndGold,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.certificateAndGoldLoading,
      payload: false,
    });
  }
}

export function* certificateAndGold() {
  yield takeLatest(actionTypes.certificateAndGoldAsync, handleWorker);
}
